import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type ActivityState = CommonTableState;

const initialState: ActivityState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {},
        columnOrder: [
            "code",
            "description",
            "useAsDefault",
            "valid",
            "clientId",
            "externalId",
            "note",
            "created",
            "creator",
            "modified",
            "modifier",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const activitySlice = createSlice({
    name: "activity",
    initialState: initialState,
    reducers: {
        updateActivityTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateActivityTableState } = activitySlice.actions;

export default activitySlice.reducer;
